var _path, _ellipse, _ellipse2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileCrmLogo = function SvgMobileCrmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0A0",
    d: "M16.646 12.818a.563.563 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.32 8.32 0 0 0 4.817 2.914 8.26 8.26 0 0 0 5.554-.832 8.4 8.4 0 0 0 3.77-4.2c.739-1.798.836-3.8.276-5.662a8.4 8.4 0 0 0-3.345-4.553 8.27 8.27 0 0 0-7.124-1.032 8.3 8.3 0 0 0-1.691.747 8.4 8.4 0 0 1 3.079 3.131l.002-.036.017.03a8.5 8.5 0 0 1 1.067 3.56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.333,
    cy: 13.414,
    fill: "#fff",
    rx: 8.333,
    ry: 8.413
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.333,
    cy: 13.414,
    fill: "url(#paint0_linear_1_20)",
    rx: 8.333,
    ry: 8.413
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1_20)",
    d: "M12.502 20.7a8.43 8.43 0 0 0 4.165-7.287c.007-.34-.021-.595-.021-.595a.57.57 0 0 1-.572.595H8.926a.563.563 0 0 0-.572.595 8.46 8.46 0 0 0 1.87 4.743 8.4 8.4 0 0 0 2.278 1.95"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_20",
    x1: 2.538,
    x2: 16.723,
    y1: 8.363,
    y2: 15.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D2D2",
    stopOpacity: 0.29
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_20",
    x1: 17.571,
    x2: 4.308,
    y1: 17.755,
    y2: 15.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D2D2"
  })))));
};
export default SvgMobileCrmLogo;